import { BroadcastFilter } from 'components/Broadcast/filter';
import { ApiConsumer } from 'api/ApiConsumer';
import { PageTitleContext } from 'context/PageTitleContext';
import { useContext, useEffect, useState } from 'react';
import BroadcastCards from 'components/Broadcast/cards';
import { CrumbsContext } from 'context/CrumbsContext';
import { API_ROUTES } from 'routes/api';

export default function Monitoring() {
  const [searchDetails, setSearch] = useState('');
  const [filter, setFilter] = useState('ALL');
  let { setTitle } = useContext(PageTitleContext);
  let { setCrumbs } = useContext(CrumbsContext);

  const [loadingChannels, setLoadingChannels] = useState(true);
  const [channels, setChannels] = useState([]);

  useEffect(() => {
    setTitle('Broadcast Monitoring');
    setCrumbs([
      { name: 'Monitoring', link: '/monitoring' },
      { name: 'Broadcast Monitoring', link: '/monitoring' },
    ]);

    ApiConsumer.get(API_ROUTES.BROADCAST.CHANNELS)
      .then((res) => {
        setChannels(res.data);

        setSearch((prevState) => ({
          ...prevState,
          [`filters`]: [
            'ALL',
            ...Array.from(new Set(res.data.map((item) => item.type))),
          ],
        }));
      })
      .catch((err) => console.error(err))
      .finally(() => setLoadingChannels(false));
  }, []);

  return (
    <>
      <div className="min-h-full px-5 py-5 mt-0 mb-16">
        <BroadcastFilter
          setDetails={setSearch}
          details={searchDetails}
          options={[]}
          onFilter={setFilter}
          activeFilter={filter}
          filterKeys={searchDetails.filters}
        />
        <BroadcastCards
          term={searchDetails.term}
          typeFilter={filter}
          loading={loadingChannels}
          channels={channels}
          defaultFilter={'ALL'}
        />
      </div>
    </>
  );
}
